<!-- Daily Rank Popup-->
<template>
  <div class="dr-popup-overlay">
    <div class="dr-popup-content" @click.stop>
      <div class="dr-popup-header">
        <h3>예비사업주 관리</h3>
      </div>

      <div class="popup-body">
        <div class="left-section">
          <div class="input-group">
            <div class="input-fields">
              <br /><br />
              <div class="input-row">
                <label for="new-name">이름</label>
                <input id="new-name" v-model="newPboName" required />
              </div>
              <div class="input-row">
                <label for="new-career">경력</label>
                <input id="new-career" v-model="newPboCareer" />
              </div>
            </div>
            <button @click="addNewRow" class="btn-add">▶추가</button>
          </div>
          <select
            v-model="selectedBranch"
            class="branch-select"
            :disabled="userInfo && userInfo.BRANCH_CD"
          >
            <option
              v-for="branch in branchList"
              :key="branch.BRANCH_CD"
              :value="branch"
            >
              {{ branch.BRANCH_NM }}
            </option>
          </select>
        </div>
        <div class="right-section">
          <ag-grid-vue
            class="ag-dr-pop-balham"
            :columnDefs="columnDefs"
            :rowData="pboData"
            :gridOptions="gridOptions"
            :theme="theme"
            @grid-ready="onGridReady"
            style="height: 400px"
          />
        </div>
      </div>

      <div class="dr-popup-footer">
        <button @click="closePopup" class="btn-close">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "DrListPopPage",
  components: { AgGridVue },
  data() {
    return {
      userInfo: null,
      selectedBranch: "",
      newPboName: "",
      newPboCareer: "",
      gridApi: null,

      branchList: [],

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        headerHeight: 25,
        rowHeight: 20,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),
      pboData: [],
      columnDefs: [
        {
          headerName: "",
          field: "rowIndex",
          valueGetter: "node.rowIndex + 1",
          cellStyle: {
            backgroundColor: "#f0f0f0",
          },
          width: 30,
        },
        {
          headerName: "이름",
          field: "NAME",
          width: 100,
        },
        {
          headerName: "경력",
          field: "CAREER",
          width: 80,
        },
        {
          headerName: "",
          field: "deleted",
          width: 120,
          cellRenderer: (params) => {
            const button = document.createElement("button");
            button.className = "btn-delete";
            button.innerText = "삭제";

            button.addEventListener("click", () => {
              params.context.componentParent.deleteSelected(params);
            });

            return button;
          },
        },
      ],
      gridOptions: {
        context: { componentParent: this },
        defaultColDef: {
          sortable: false,
          headerStyle: {
            color: "black",
            backgroundColor: "#f0f0f0",
          },
        },
      },
    };
  },
  methods: {
    async fetchBranchList() {
      try {
        const res = await axios.get("/api/drListPage/center");
        this.branchList = res.data;

        if (this.userInfo && this.userInfo.BRANCH_CD) {
          const userBranch = this.branchList.find(
            (branch) => branch.BRANCH_CD === this.userInfo.BRANCH_CD
          );
          if (userBranch) {
            this.selectedBranch = userBranch;
          }
        } else if (this.branchList && this.branchList.length > 0) {
          this.selectedBranch = this.branchList[0];
        }
      } catch (error) {
        console.error("본부 목록 로딩 실패:", error);
        alert("본부 목록을 불러오는 데 실패했습니다.");
      }
    },

    async loadPboData() {
      try {
        const response = await axios.get("/api/drListPage/pboList", {
          params: { branchCd: this.selectedBranch.BRANCH_CD },
        });
        this.pboData = response.data;
      } catch (error) {
        console.error("데이터 로딩 실패:", error);
      }
    },

    onGridReady(params) {
      this.gridApi = params.api;
    },

    async addNewRow() {
      if (!this.selectedBranch || this.selectedBranch.BRANCH_CD === "00") {
        alert("본부를 선택해주세요.");
        return;
      }
      if (!this.newPboName) {
        alert("이름을 입력해주세요.");
        return;
      }

      if (!this.newPboCareer) {
        alert("경력을 입력해주세요.");
        return;
      }

      if (
        this.userInfo &&
        this.userInfo.BRANCH_CD &&
        this.selectedBranch.BRANCH_CD !== this.userInfo.BRANCH_CD
      ) {
        if (
          !confirm(
            "선택된 본부가 로그인된 본부와 다릅니다. 계속하시겠습니까?"
          )
        ) {
          return;
        }
      }

      const newRow = {
        BRANCH_CD: this.selectedBranch.BRANCH_CD,
        NAME: this.newPboName,
        CAREER: this.newPboCareer,
      };
      try {
        await axios.post("/api/drListPage/saveDrPboData", newRow);
        alert("성공적으로 저장되었습니다.");
        this.loadPboData();
        this.newPboName = "";
        this.newPboCareer = "";
      } catch (error) {
        console.error("Failed to save data:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },

    async deleteSelected(params) {
      const rowId = params.data.ID;
      if (!rowId) {
        alert("삭제할 항목을 선택해주세요.");
        return;
      }
      if (confirm("항목을 삭제하시겠습니까?")) {
        await axios.post("/api/drListPage/deleteDrPboData", { ROWID: rowId });
        alert("삭제되었습니다.");
        this.loadPboData();
      }
    },

    closePopup() {
      this.$emit("close");
    },
  },
  watch: {
    selectedBranch() {
      if (this.selectedBranch && this.selectedBranch.BRANCH_CD !== "00") {
        this.loadPboData();
      }
    },
  },
  created() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }
    this.fetchBranchList();
  },
  mounted() {
  },
};
</script>

<style scoped>
.dr-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dr-popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 600px;
  cursor: default; /* 팝업 내 기본 커서를 표준 화살표로 설정 */
}

.dr-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: black;
}

.popup-body {
  display: grid;
  grid-template-columns: 4fr 6fr;
  gap: 10px;
}

.input-group {
  display: flex;
  align-items: center;
}

.input-fields {
  display: flex;
  flex-direction: column;
}

.input-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.input-row label {
  width: 3rem;
  color: black;
  font-size: 1rem;
}

.input-row input {
  width: 8rem;
  font-size: 1rem;
  cursor: text; /* 입력 필드 커서를 텍스트 입력 형태로 설정 */
}

.branch-select {
  padding: 5px;
  width: 11.8rem;
  margin-top: 10px;
  float: right;
}

.dr-popup-footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-add,
.btn-delete,
.btn-close {
  padding: 5px 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-add {
  background: #4caf50;
  color: white;
  margin-left: 5px;
  margin-top: 25px;
}
:deep(.btn-delete) {
  background-color: #c0c0c0;
  color: black;
  border: none;
  padding: 0px 30px;
  border-radius: 2px;
  cursor: pointer;
}

.btn-close {
  background: #9e9e9e;
  color: white;
}

:deep(.ag-dr-pop-balham .ag-header-cell-label) {
  justify-content: center !important;
  font-weight: normal;
}
</style>
